/** @format */

/**
 * Измеряет точную ширину текста в пикселях
 */
export const measureTextWidth = (
  text: string,
  fontSize: number = 14,
  fontWeight: number = 400,
): number => {
  // Создаём временный canvas элемент для измерения
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) return text.length * 6.5; // fallback

  // Устанавливаем те же параметры шрифта, что и в SVG
  context.font = `${fontWeight} ${fontSize}px sans-serif`;

  // Измеряем ширину текста
  const metrics = context.measureText(text);

  return metrics.width;
};

